import { generateTestId } from "@client-shared";

export const setRoleSelectorTestId = (identifier: string): string => generateTestId("RoleSelector", identifier);

// Specific element testIds
export const setRoleSelectorContainerTestId = (): string => setRoleSelectorTestId("container");

export const setRoleSelectorTitleTestId = (): string => setRoleSelectorTestId("title");

export const setRoleSelectorDescriptionTestId = (): string => setRoleSelectorTestId("description");

export const setRoleSelectorCurrentRoleLabelTestId = (): string => setRoleSelectorTestId("current-role-label");
